import { render, staticRenderFns } from "./CartPay.vue?vue&type=template&id=654e8a3c"
import script from "./CartPay.vue?vue&type=script&lang=js"
export * from "./CartPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports